export default {
  fields: {
    discount: {
      label: 'Rabat',
    },
    usage_threshold: {
      label: 'Minimalna kwota zamówienia',
    },
    max_discount: {
      label: 'Maksymalna kwota rabatu',
    },
  },
};
